<template>
  <v-dialog v-model="dialog" max-width="1200px">
    <v-card>
      <v-card-title class="mx-3">
        {{ pageType == 'in' ? $t("Requisition.importErrTitle") : $t("Requisition.importOutErrTitle") }}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          {{ $t("$vuetify.close") }}
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-4 py-8 text-center subtitle-1">
        <v-data-table
          :headers="headers"
          :items="errorPricing"
          multi-sort
          class="elevation-1 px-4 pt-2"
          disable-pagination
          hide-default-footer
          fixed-header
        >
          <template v-slot:item.error_msg="{ item }">
            <span class="red--text">
              {{ item.error_msg }}
            </span>
          </template>
          <template v-slot:item.Description="{ item }">
            {{ item.material_name }}
            <br />
            <span v-if="item.standard_name" class="caption secondary--text">
              {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")}}
              <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
                {{ item.standard_name.slice(0, 12) + "......" }}
              </span>
              <span v-else>
                {{ item.standard_name }}
              </span>
            </span>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" outlined @click="dialog = false">
          {{ $t("$vuetify.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";

export default {
  name: "ImportPricingResult",

  props: {
    value: Boolean,
    errorPricing: Array,
    pageType: String,
  },
  computed: {
    headers: () => [
      {
        text: i18n.t("Requisition.DetailFields.material_name"),
        align: "start",
        sortable: false,
        value: "Description",
        width: 380,
      },
      {
        text: i18n.t("Requisition.DetailFields.material_category"),
        align: "start",
        sortable: false,
        value: "category_name",
      },
      {
        text: i18n.t("Requisition.DetailFields.total_num"),
        align: "start",
        sortable: false,
        value: "requisition_num",
      },
      {
        text: i18n.t("Requisition.DetailFields.unit"),
        align: "start",
        sortable: false,
        value: "unit",
      },
      {
        text: i18n.t("Requisition.importErrMsg"),
        align: "start",
        sortable: false,
        value: "error_msg",
      },
    ],
    ...mapState(["loading"]),
  },
  data: () => ({
    dialog: false,
  }),
  methods: {},

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
      },
    },
  },
};
</script>